import { toast } from "react-toastify";

export const unexpectedError = () => {
    return toast.error("Error 500: A aparut o eroare", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        // progress: 1
    })
}

export const expectedError = (text, toastId = "unique") => {
    return toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        toastId
        // progress: 1
    })
}

export const expectedWarning = (text, toastId = "unique") => {
    return toast.warn(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        toastId
        // progress: 1
    })
}


export const handleApiErrors = (error) => {
    if (error.response) {

        if (error.response && error.response.data) {
            return expectedError(error.response.data.message);
        }
        // THIS IS A SERVER ERROR AND WE SHOULD DISPLAY IT 
        return unexpectedError();
    }

    // THIS IS A CANCELED REQUESTED FROM A USER AND WE SHOULDN'T DO ANYTHING
}